import { Text } from '@components/ui';
import { ApiUrl } from '@config/apiUrl';
import apiProtected from '@lib/api/apiClient';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactPlayer from 'react-player';

import type { RatingVideo } from './uploadedVideosTypes';

interface UploadedVideosProps {
  jobData?: {
    id?: string | number;
  };
}

const UploadedVideos = ({ jobData }: UploadedVideosProps): JSX.Element => {
  const { t } = useTranslation();
  const [videos, setVideos] = useState<RatingVideo[]>([]);

  useEffect(() => {
    if (jobData?.id == null) return;
    apiProtected
      .get(
        `${ApiUrl.server_url}v1/rating-criteria-users/get-rating-videos?jobId=${jobData.id}`
      )
      .then((res) => {
        setVideos(res?.data?.data ?? []);
      });
  }, [jobData?.id]);

  return (
    <Box sx={{ mt: 2, width: '100%' }}>
      <Box sx={{ mb: 1.5, width: '100%', borderBottom: 1, borderColor: 'divider', pb: 1 }}>
        <Text variant="subtitle" sx={{ m: 0, fontSize: 18, fontWeight: 700, textTransform: 'uppercase' }}>
          {t('jobs.videos')}
        </Text>
      </Box>

      <Grid container spacing={1.5} sx={{ mt: 1 }}>
        {videos.length > 0 ? (
          videos.map((item) => (
            <Grid item key={item.id ?? item.url} xs={12} sm={6} md={4} lg={3}>
              <Box
                sx={{
                  width: '100%',
                  overflow: 'hidden',
                  borderRadius: '10px',
                  border: 1,
                  borderColor: 'divider',
                  bgcolor: 'background.default',
                }}
              >
                <ReactPlayer
                  url={item.url}
                  width="100%"
                  height="160px"
                  controls
                />
              </Box>
            </Grid>
          ))
        ) : (
          <Grid item xs={12}>
            <Box
              sx={{
                display: 'flex',
                minHeight: 72,
                width: '100%',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '10px',
                border: 1,
                borderColor: 'divider',
                bgcolor: 'background.default',
                fontWeight: 700,
                textTransform: 'uppercase',
                color: 'text.secondary',
              }}
            >
              {t('jobs.noVideo')}
            </Box>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default UploadedVideos;
